import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactformComponent } from './components/contactform/contactform.component';
import { IndexPictureCarouselComponent } from './components/index-picture-carousel/index-picture-carousel.component';
import { ArtgalleryComponent } from './components/gallery/artgallery/artgallery.component';
import { ImageModule } from './components/utility/image/image.module';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { GallerysidenavComponent } from './components/gallerysidenav/gallerysidenav.component';
import { ShopsidenavComponent } from './components/shopsidenav/shopsidenav.component';
import { RouterModule } from '@angular/router';
import { LoadSpinnerComponent } from './components/load-spinner/load-spinner.component';
import { LowQImageModule } from './components/utility/low-qimage/low-qimage.module';
import { FooterContainerComponent } from './components/footer-container/footer-container.component';
import { Image2Module } from './components/utility/image2/image2.module';



@NgModule({
  declarations: [
    ContactformComponent,
    IndexPictureCarouselComponent,
    ArtgalleryComponent,
    SidenavComponent,
    GallerysidenavComponent,
    ShopsidenavComponent,
    LoadSpinnerComponent,
    FooterContainerComponent,
    
  ],
  imports: [
    CommonModule,
    ImageModule,
    RouterModule,
    LowQImageModule,
    Image2Module
  ],
  exports: [
    ContactformComponent,
    IndexPictureCarouselComponent,
    ArtgalleryComponent,
    ImageModule,
    SidenavComponent,
    GallerysidenavComponent,
    ShopsidenavComponent,
    LoadSpinnerComponent,
    LowQImageModule,
    Image2Module,
    FooterContainerComponent
    
  ]
})
export class SharedModule { }
